import { render, staticRenderFns } from "./GroupCollectionFilters.vue?vue&type=template&id=8f7c6832"
import script from "./GroupCollectionFilters.vue?vue&type=script&lang=ts"
export * from "./GroupCollectionFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7c6832')) {
      api.createRecord('8f7c6832', component.options)
    } else {
      api.reload('8f7c6832', component.options)
    }
    module.hot.accept("./GroupCollectionFilters.vue?vue&type=template&id=8f7c6832", function () {
      api.rerender('8f7c6832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupCollectionFilters.vue"
export default component.exports